/**
 * Fine-tuning API returns primary rows in `groups[]` (group_by_base_model=true).
 * Legacy responses used `agents[]`. Prefer groups when present.
 */
export function getFineTuningGroups(payload: unknown): any[] {
  if (payload == null) return [];
  const root = payload as Record<string, unknown>;
  const inner =
    root && typeof root.data === 'object' && root.data !== null && !Array.isArray(root.data)
      ? (root.data as Record<string, unknown>)
      : (root as Record<string, unknown>);

  if (Array.isArray(inner.groups) && inner.groups.length > 0) {
    return inner.groups as any[];
  }
  if (Array.isArray(inner.agents) && inner.agents.length > 0) {
    return inner.agents as any[];
  }
  return [];
}

/** Unwrap ApiResponse or raw training preview / job payload */
export function unwrapTrainingPayload(resp: unknown): Record<string, unknown> {
  if (resp == null || typeof resp !== 'object') return {};
  const r = resp as Record<string, unknown>;
  if (r.data !== undefined && typeof r.data === 'object' && r.data !== null && !Array.isArray(r.data)) {
    return r.data as Record<string, unknown>;
  }
  return r as Record<string, unknown>;
}
